import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 15.7 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.684",
      d: "M.842 4.057h1.823m12.24 0h-1.693m-2.343 0V.842h-5.99v3.215m5.99 0h-5.99m5.99 0h2.343m-8.333 0H2.665m0 0v10.848h10.547V4.057M6.051 7.539l1.823 1.808m1.823 1.808L7.874 9.347m0 0 1.823-1.808-3.646 3.616"
    }, null, -1)
  ]))]))
}
export default { render: render }